document.addEventListener("DOMContentLoaded", function () {

  const academyLinks = document.querySelectorAll('a[href="/#academy"]');

  academyLinks.forEach(link => {

    link.addEventListener("click", function(e) {

      // If already on homepage
      if (window.location.pathname === "/") {

        e.preventDefault();

        document.getElementById("academy").scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

      }
      // Otherwise go to homepage
      else {

        e.preventDefault();

        window.location.href = "/#academy";

      }

    });

  });

  // Scroll after homepage loads
  if (window.location.hash === "#academy") {

    setTimeout(function () {

      const section = document.getElementById("academy");

      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }

    }, 300);

  }

});